import { makeStyles } from '@mui/styles';
import {
  CcfBox,
  CcfButton,
  CcfCard,
  CcfPopOver,
  CcfTextField,
  CcfTypography,
  PopOverMenuItem,
  useTranslator,
} from '@nice-ccf/ui-controls';
import {
  getInteractionTabs,
  getActiveInteractionID,
  updatePropertyOfAgentReply,
} from './../../../ccf-inbox/ccf-inbox.slice';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedConsultantForChat } from '../../../ccf-interaction-tabs/ccf-chat-box/+state/ccf-chat-box.state';
import { selectLoginCredentialsState } from '../../../login/+state/login.slice';
import { activeContactSelector } from '../../ccf-inbox.slice';
import styles from './ccf-customer-notes.module.scss';
import {
  getIsEditContactCardNote,
  getIsEditInlineNote,
  globalActions,
} from '../../../global.app.slice';
import { useMsal } from '@azure/msal-react';

/* eslint-disable-next-line */
export interface CcfCustomerCardAddNotesProps {
  isFromWebChat?: boolean;
  handleCancelNote?: any;
  handleDeleteNote?: any;
  notesContentFromWebChat?: string;
  notesContentFromContactCard?: any;
  handleSaveNoteContactCard?: any;
  noteId?: any;
  handleEditNoteContactCard?: any;
  isEditModeOn?: boolean;
}

const useStyles = makeStyles((theme) => ({
  customRootClass: {
    '&.MuiIconButton-root': { padding: '0px' },
  },
}));

/**
 * CcfCustomerCard used to disply active contact customer details in the AppSpace
 * @param props --? - CcfCustomerCardProps
 * @example -- <CcfCustomerCard />
 */
export function CcfCustomerCardAddNotes(props?: CcfCustomerCardAddNotesProps) {
  const [translate] = useTranslator();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const activeContact = useSelector(activeContactSelector);
  const loginCredentials = useSelector(selectLoginCredentialsState);
  const userInChatConsult = useSelector(selectedConsultantForChat);
  const interactionTabs = useSelector(getInteractionTabs) || {};
  const activeInteractionID: string = useSelector(getActiveInteractionID) || '';
  const chatInputRef = useRef<any>(null);
  const {  accounts } = useMsal();
  const loginCredentialsFromSSO = accounts[0]?.name || " ";
  const loginCredentialsArray = loginCredentialsFromSSO?.split(" ");
  const agentFirstName = loginCredentialsArray[0].charAt(0).toUpperCase() + loginCredentialsArray[0].slice(1).toLowerCase();
  const agentSurName = loginCredentialsArray[1].charAt(0).toUpperCase() + loginCredentialsArray[1].slice(1).toLowerCase();
  const isEditInlineNote = useSelector(getIsEditInlineNote);
  const isEditContactCardNote = useSelector(getIsEditContactCardNote);
  const { setIsEditInlineNote, setIsEditContactCardNote } = globalActions;
  const [textFieldMessage, setTextFieldMessage] = useState(
    props?.isFromWebChat
      ? props?.notesContentFromWebChat
      : props?.notesContentFromContactCard?.message
  );
  const [updatedNoteValue, setUpdatedNoteValue] = useState('');

  useEffect(() => {
    if (!props?.isFromWebChat) {
      setTextFieldMessage(props?.notesContentFromContactCard?.message);
    } else {
      setTextFieldMessage(props?.notesContentFromWebChat);
    }
  }, [
    props?.notesContentFromContactCard?.isEdit,
    props?.isEditModeOn,
    props?.notesContentFromContactCard?.message,
  ]);
  const dispatch = useDispatch();

  /**
   *
   */
  const shiftEnterFunction = useCallback(
    (e: any) => {
      if (
        props?.isFromWebChat &&
        e.key === 'Enter' &&
        e.shiftKey &&
        updatedNoteValue
      ) {
        saveClickHandler(e, 'Save');
      }
    },
    [updatedNoteValue]
  );

  useEffect(() => {
    document.addEventListener('keydown', shiftEnterFunction, false);
    return () => {
      document.removeEventListener('keydown', shiftEnterFunction, false);
    };
  }, [shiftEnterFunction]);

  /**
   *Handle click for overflow icon
   * @param event - any
   * @example handleClick(event)
   */
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   *Save click hand;er for notes
   * @param event - any
   * @example saveClickHandler(event)
   */
  const saveClickHandler = (e: any, userAction: string) => {
    if (props?.isFromWebChat) {
      //dispatch(setIsEditInlineNote(false));
      dispatch(
        updatePropertyOfAgentReply({
          interactionId: activeInteractionID,
          replyMessage: chatInputRef?.current?.value,
          deleteTweetId: props?.noteId,
          actionType: userAction,
        })
      );

      document.getElementById('bodyContainer')?.scroll({
        top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
        behavior: 'smooth', //auto, smooth, initial, inherit
      });
    } else {
      dispatch(setIsEditContactCardNote(false));
      props?.handleSaveNoteContactCard(
        chatInputRef?.current ? chatInputRef?.current.value : updatedNoteValue,
        props?.noteId
      );
    }
  };

  const dropdownOptions = {
    menuItems: [
      {
        items: [
          {
            label: translate('edit'),
            closeOnSelection: true,
          },
          {
            label: translate('delete'),
            closeOnSelection: true,
          },
        ],
      },
    ],
  };

  /**
   * Edit Note handler
   * @param e -
   * @example -
   */
  const handleEdit = () => {
    if (!props?.isFromWebChat) {
      dispatch(setIsEditContactCardNote(true));
      props?.handleEditNoteContactCard(props?.noteId);
    } else {
      // dispatch(setIsEditInlineNote(true));
      dispatch(
        updatePropertyOfAgentReply({
          interactionId: activeInteractionID,
          deleteTweetId: props?.noteId,
          actionType: 'Edit',
        })
      );
    }
  };

  /**
   *Handle click for overflow icon
   * @param event - any
   * @example handleClick(event)
   */
  const updateFieldValue = (event: any) => {
    setTextFieldMessage(event.currentTarget.value);
    setUpdatedNoteValue(event.currentTarget.value);
  };

  /**
   * Function is helps in calling function when button is clicked on popup
   * @param item -String
   * @returns Function
   * @example onPopOverItemSelections('fetchingInteractions')
   */
  const onPopOverItemSelection = (item: PopOverMenuItem) => () => {
    switch (item.label) {
      case translate('edit'):
        return handleEdit();
      case translate('delete'):
        return props?.isFromWebChat
          ? dispatch(
              updatePropertyOfAgentReply({
                interactionId: activeInteractionID,
                deleteTweetId: props?.noteId,
                actionType: 'InitialCancel',
              })
            )
          : props?.handleDeleteNote(props?.noteId);
      default:
        return console.log('Please select correct option');
    }
  };
  return (
    <>
      {props?.isFromWebChat && (
        <CcfBox className={styles.agentName}>{agentFirstName +" " + agentSurName}</CcfBox>
      )}
      <CcfCard
        className={
          !props?.isFromWebChat
            ? styles.addNotesContactCard
            : props.isEditModeOn
            ? styles.addNotesChatCard
            : styles.addNotesChatCardNotEdited
        }
      >
        <CcfBox
          className={
            props?.isFromWebChat
              ? styles.addNotesChatHeader
              : styles.addNotesContactHeader
          }
        >
          {props?.isFromWebChat ? (
            <CcfTypography className={styles.addNotesChatHeaderText}>
              {' '}
              {`${translate('note')}:`}
            </CcfTypography>
          ) : (
            <CcfTypography className={styles.addNotesContactHeaderText}>
              {agentFirstName +" " + agentSurName}
            </CcfTypography>
          )}
          {props?.isFromWebChat ? (
            !props?.isEditModeOn && (
              <div
                style={{ marginRight: '5px' }}
                className={styles.bookmarkContent}
              >
                <CcfPopOver
                  onPopOverItemSelection={onPopOverItemSelection}
                  optionList={dropdownOptions}
                />
              </div>
            )
          ) : (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {!props?.isFromWebChat && (
                <CcfTypography style={{ fontSize: '12px' }}>
                  {props?.notesContentFromContactCard?.edited && (
                    <i> edited </i>
                  )}{' '}
                  &nbsp; {new Date().toLocaleDateString('en-US')}
                </CcfTypography>
              )}

              {!props?.notesContentFromContactCard?.isEdit && (
                <div className={styles.bookmarkContent}>
                  <CcfPopOver
                    onPopOverItemSelection={onPopOverItemSelection}
                    optionList={dropdownOptions}
                  />
                </div>
              )}
            </div>
          )}
        </CcfBox>
        {(props?.isFromWebChat && props.isEditModeOn) ||
        (!props?.isFromWebChat &&
          isEditContactCardNote &&
          props?.notesContentFromContactCard?.isEdit) ? (
          <CcfTextField
            id="textFieldMessage"
            className={
              props?.isFromWebChat
                ? styles.addNotesChatTextBox
                : styles.addNotesContactTextBox
            }
            multiline
            rows={3}
            maxRows={3}
            autoFocus={false}
            InputProps={{ disableUnderline: true }}
            inputRef={chatInputRef}
            value={textFieldMessage}
            onChange={(e) => {
              updateFieldValue(e);
            }}
          ></CcfTextField>
        ) : (
          <CcfBox>
            <CcfTypography
              style={{ marginLeft: props?.isFromWebChat ? '15px' : '0px' }}
              className={styles.textFieldMsgText}
            >
              {textFieldMessage}
            </CcfTypography>
          </CcfBox>
        )}
        {((props?.isFromWebChat && props.isEditModeOn) ||
          (!props?.isFromWebChat &&
            isEditContactCardNote &&
            props?.notesContentFromContactCard.isEdit)) && (
          <CcfBox
            className={styles.addNoteChatBtnContainer}
            style={{
              cursor: textFieldMessage ? 'pointer' : 'not-allowed',
            }}
          >
            <CcfButton
              className={styles.addNoteChatSaveButton}
              onClick={(e) => saveClickHandler(e, 'Save')}
              disabled={!textFieldMessage}
            >
              <CcfTypography
                className={styles.txtSave}
                style={{
                  color: textFieldMessage ? '#ffffff' : '#003d78',
                }}
              >
                {translate('save')}
              </CcfTypography>
            </CcfButton>
            <CcfButton
              className={styles.addNoteChatCancelButton}
              onClick={(e) =>
                props?.handleCancelNote(
                  props?.notesContentFromWebChat?.length
                    ? 'Cancel'
                    : 'InitialCancel',
                  e,
                  props?.noteId,
                  props?.notesContentFromContactCard?.message
                )
              }
            >
              <CcfTypography className={styles.txtCancel}>{translate('cancel')}</CcfTypography>
            </CcfButton>
          </CcfBox>
        )}
      </CcfCard>
    </>
  );
}

export default CcfCustomerCardAddNotes;
